import http from './http';
import { CREATED, OK, UNPROCESSABLE_CONTENT } from '../utils/constant';

const resourcePath = 'data-permission-templates';

const DataPermissionTemplateService = {
    getList: async (queryStrings) => {
        try {
            const queryString = new URLSearchParams(queryStrings).toString();
            const response = await http.GET(`${resourcePath}?${queryString}`);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching data permission template list:', error);
            throw error;
        }
    },
    getById: async (id) => {
        try {
            const response = await http.GET(`${resourcePath}/${id}`);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching data permission template by ID:', error);
            throw error;
        }
    },
    createTemplate: async (data) => {
        try {
            const response = await http.POST(`${resourcePath}`, data);
            if ((response.code === OK || response.code === CREATED) && response.data) {
                return response;
            }
            if (response.code === UNPROCESSABLE_CONTENT && response.data) {
                return response;
            }
            return null;
        } catch (error) {
            console.error('Error creating data permission template:', error);
            throw error;
        }
    },
    updateTemplate: async (id, data) => {
        try {
            const response = await http.PUT(`${resourcePath}/${id}`, data);
            if ((response.code === OK || response.code === CREATED) && response.data) {
                return response;
            }
            if (response.code === UNPROCESSABLE_CONTENT && response.data) {
                return response;
            }
            return null;
        } catch (error) {
            console.error('Error updating data permission template:', error);
            throw error;
        }
    },
    deleteTemplate: async (id) => {
        try {
            const response = await http.DELETE(`${resourcePath}/${id}`);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error deleting data permission template:', error);
            throw error;
        }
    },
};

export default DataPermissionTemplateService;
